import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"selectBox",staticStyle:{"display":"none"}},[_c(VSelect,{attrs:{"items":_vm.languageList,"item-text":"text","item-value":"value","label":"Language","hide-details":"auto","solo":""},on:{"change":_vm.onSelectLanguage},model:{value:(_vm.nowLang),callback:function ($$v) {_vm.nowLang=$$v},expression:"nowLang"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }